module.exports = __webpack_public_path__ + "static/media/down_arrow.72b5c8eb.svg";